import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import $ from 'jquery'

const Home = () => {
  let[chatdisplay, setchatdisplay]=useState(true)
  let[seconds, setSeconds]=useState(0)
  let[rrr, setrrr]=useState([])
  let location = useLocation()
  let ls= location.state
  let m = ls.messages!=null ? ls.messages : []
  let [msg, setMsg]= useState(m)
  let r=''
  // console.log("&&&&&&&&&&&&&&&&&&&&&&&77")
  useEffect(()=>{
    // $(".name").click(()=>{
    //   // alert("j")
    //   $(this).children('.chat').toggle()
    // })
    $('.chat').scrollTop(1000000);
    resultt()
  },[msg])

  $('.chat').scrollTop(1000000);

  let sendmessage=async(e)=>{
    e.preventDefault()
    let fdata = new FormData(e.currentTarget)
    let adata = {
      from:fdata.get("from"),
      to:fdata.get("to"),
      message:fdata.get("message")
    }
    // console.log(adata)
    r = await axios.post("https://whatsappbac.vercel.app/usermessage", adata)
    // console.log("sended", await r.data)
    // console.log("setmsg")
   
    setMsg(await r.data.messages)
  }

  let refresh=async(e)=>{
    e.preventDefault()
    r=await axios.get(`https://whatsappbac.vercel.app/${ls.email}/`)
    // console.log("ref", await r.data.messages)
   
    setMsg(await r.data.messages)
  }

  let user = ls.email
 
  let result=[]
  let uniqueCombinations
  let contactedto
  async function resultt(){
    const r = await axios.get(`https://whatsappbac.vercel.app/${ls.email}/`)
    // console.log("result", r.data)
    m=r.data.messages  

    contactedto = m.map((contact)=>{
      return {"to":contact.to, "from":contact.from}
    })
  
     uniqueCombinations = {};
  
    // Loop through the array of objects
    for (let i = 0; i < contactedto.length; i++) {
      let { to, from } = contactedto[i];
      
      // Check if the combination already exists in the object
      if (!uniqueCombinations[`${to}-${from}`] && !uniqueCombinations[`${from}-${to}`]) {
        // Add the combination to the object if it doesn't exist
        uniqueCombinations[`${to}-${from}`] = true;
      }
    }
     result = Object.keys(uniqueCombinations).map((key) => {
      let [to, from] = key.split('-');
      return { to, from };
    });
    
    // console.log(res)
    // console.log(result)
    setrrr(result)

  }

  let[chatters, setchatters]=useState([])
  let search = async (e)=>{
    e.preventDefault()
    let r = await axios.get("https://whatsappbac.vercel.app/searchusers")
    setchatters(r.data.users)
    // console.log("chatter",chatters)
  }
 
  return (
    <>
    <div className='container'>
    <h1 style={{backgroundColor:"red", color:"white", padding:"5px"}} onClick={refresh}>
      Chit-Chat 
      <a className='text-decoration-none' href='/' style={{marginLeft:"20%", borderBottom:"white 2px solid", color:"white"}}>
        Welcome {ls.name}
      </a>
    </h1>
    <div className='container'>
      {
        rrr.map((con,i)=>{
          return <>
          <h5 className='name' style={{color:"red", border:"solid 1px red", padding:"5px", cursor:"pointer"}} key={con.to} onClick={refresh}  >
            {
            con.to!=user ?  <span className='cli' onClick={()=>{
                chatdisplay==false ? setchatdisplay(true) : setchatdisplay(false)
              } }>
              {con.to} 
              </span> : 
              <span onClick={()=>{
                chatdisplay==false ? setchatdisplay(true) : setchatdisplay(false)
              } }>{con.from}</span>
            }
           </h5>
           {
            chatdisplay && 
            <div className='container chat' style={{height:"20vh"}} >
              {
                msg.map((message)=>{
                  return <>
                  <div className='' >
                    {/* hismessage */}
                    <div className='d-flex flex-row' style={{color:"blue"}}>
                      <span className='me-3' style={{fontSize:".6vw"}}>
                        {
                          message.from===(con.to!=user? con.to : con.from) && message.to===user && message.time
                        }

                      </span>
                      {
                        message.from===(con.to!=user? con.to : con.from) && message.to===user && message.message
                      }
                     
                    </div>

                    {/* ourmessage */}
                    <div className='d-flex flex-row-reverse' style={{color:"black"}}>
                      <span className='ms-3' style={{fontSize:".6vw"}}>
                        {
                          message.from===user && message.to===(con.to!=user? con.to : con.from) && message.time 
                        }

                      </span>
                      {
                        message.from===user && message.to===(con.to!=user? con.to : con.from) && message.message 
                      }
                     
                    </div>
                  </div>
                  </> 
                })
              }
              
            </div>
           }
            <form className='form' onSubmit={sendmessage}>
              <input type="hidden" name="from" value={user} />
              <input type="hidden" name="to" value={con.to!=user ? con.to : con.from } />
              <input type="text" style={{width:"60%"}} name="message" />
              <button className='btn fa fa-send' style={{color:"red"}} type="submit"></button>
            </form>
            <hr/>
          </>
        })
      }

    </div>
    <div className='container'>
      <button className='btn' style={{color:"white", backgroundColor:"red"}} onMouseEnter={()=>setchatters([])} onClick={search}>
        Add Chatter
      </button>
      {
        chatters.length!=0 &&
        chatters.map((u)=>{
          return <>
          {
            u.email!=user &&
            <h4>
              {u.name} 
              <div className='container'>
              <form onSubmit={sendmessage}>
              <input type="hidden" name="from" value={user} />
              <input type="hidden" name="to" value={u.email} />
              <input type="text" name="message" />
              <button className='btn fa fa-send' style={{color:"red"}} type="submit"></button>
              </form>
              </div>
            </h4>
          }
          </>
        })
      }
    </div>
      <div className='d-flex justify-content-end'>
        <a href="/" className='btn' style={{color:"white", backgroundColor:"red"}} >Logout</a>
      </div>
    </div>
    </>
  )
}

export default Home